import React from 'react';
import Snackbar from 'material-ui/Snackbar';
import { connect } from 'react-redux'
import { message } from '../../store/messageBar'

class MessageBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            autoHideDuration: 5000,
            message: props.message.text
        };
        this.showMessage = this.props.showMessage;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.message !== this.state.message) {
            this.setState({
                message: nextProps.message.text
            });
        }
    }

    handleRequestClose = () => {
        this.showMessage('');
    };

    render() {
      let styles = {
          top: 0,
          bottom: 'auto',
          transition: 'none'
      };
        return (
            <div>
                <Snackbar
                    className={'snack-box'}
                    open={(this.state.message !== '')}
                    message={this.state.message}
                    autoHideDuration={this.state.autoHideDuration}
                    onRequestClose={this.handleRequestClose}
                    style={styles}
                    bodyStyle={{backgroundColor: '#f4af4d', textAlign: 'center'}}
                    contentStyle={{ color: '#000', fontSize: '18px', fontWeight: 'bold'}}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        message: state.message
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        showMessage: (text) => dispatch(message(text))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessageBar);



// WEBPACK FOOTER //
// ./src/components/ModalWindow/MessageBar.js